import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconGetSupport$1 = /*@__PURE__*/ proxyCustomElement(class WppIconGetSupport extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-get-support", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M1.54166 9.99959C1.54166 5.3283 5.3287 1.54126 9.99999 1.54126C14.6713 1.54126 18.4583 5.3283 18.4583 9.99959C18.4583 14.6709 14.6713 18.4579 9.99999 18.4579C8.62009 18.4579 7.3181 18.124 6.16781 17.5377L3.02322 18.4152C3.02309 18.4153 3.02296 18.4153 3.02283 18.4153C2.14691 18.66 1.34089 17.8529 1.58556 16.9778C1.58559 16.9777 1.58562 16.9776 1.58565 16.9775C1.58566 16.9775 1.58567 16.9774 1.58569 16.9774L2.46345 13.8348C1.87595 12.6836 1.54166 11.3807 1.54166 9.99959ZM9.99999 3.04126C6.15712 3.04126 3.04166 6.15672 3.04166 9.99959C3.04166 11.2279 3.36249 12.3793 3.92165 13.3817C4.01802 13.5545 4.04223 13.7583 3.98901 13.9489L3.18942 16.8115L6.05382 16.0122C6.24416 15.9591 6.44778 15.9832 6.62041 16.0794C7.62216 16.6375 8.77288 16.9579 9.99999 16.9579C13.8429 16.9579 16.9583 13.8425 16.9583 9.99959C16.9583 6.15672 13.8429 3.04126 9.99999 3.04126ZM2.61927 16.9706C2.6194 16.9706 2.61952 16.9706 2.61965 16.9705L2.61927 16.9706ZM8.875 7.91675C8.875 7.29555 9.3788 6.79175 10 6.79175C10.6212 6.79175 11.125 7.29555 11.125 7.91675C11.125 8.44811 10.8953 8.68198 10.4254 9.12122L10.4115 9.13415C9.93365 9.58069 9.25 10.2195 9.25 11.4584C9.25 11.8726 9.58579 12.2084 10 12.2084C10.4142 12.2084 10.75 11.8726 10.75 11.4584C10.75 10.8956 10.9905 10.6462 11.4496 10.2171L11.4837 10.1852C11.9508 9.74944 12.625 9.12035 12.625 7.91675C12.625 6.46712 11.4496 5.29175 10 5.29175C8.55037 5.29175 7.375 6.46712 7.375 7.91675C7.375 8.33096 7.71079 8.66675 8.125 8.66675C8.53921 8.66675 8.875 8.33096 8.875 7.91675ZM10.8333 13.7501C10.8333 14.2103 10.4602 14.5834 9.99996 14.5834C9.53972 14.5834 9.16663 14.2103 9.16663 13.7501C9.16663 13.2898 9.53972 12.9167 9.99996 12.9167C10.4602 12.9167 10.8333 13.2898 10.8333 13.7501Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-get-support-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-get-support", "wpp-icon-get-support-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-get-support-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-get-support-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconGetSupport$1);
      }
      break;
  } });
}

const WppIconGetSupport = WppIconGetSupport$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconGetSupport, defineCustomElement };
